import { Injectable } from '@angular/core';
import { FeatureToggles } from '@core/enums/feature-toggles.enum';
import { FeatureToggleService } from '@core/services/feature-toggle.service';
import { UserService } from '@core/services/user.service';
import { distinctUntilChanged, Observable, of, switchMap } from 'rxjs';
import { LiveChatStateService } from './live-chat-state.service';
import { PhoneAgentActivationService } from './phone-agent-activation.service';

@Injectable({
  providedIn: 'root',
})
export class PhoneService {
  constructor(
    private readonly userService: UserService,
    private readonly liveChatStateService: LiveChatStateService,
    private readonly featureToggleService: FeatureToggleService,
    private readonly phoneAgentActivationService: PhoneAgentActivationService
  ) {}

  checkShowPhoneApp(): Observable<boolean> {
    return this.liveChatStateService.userHasPhonePermission$.pipe(
      distinctUntilChanged(),
      switchMap((userHasPhonePermission) => {
        if (!userHasPhonePermission || !this.checkUserHasCode7Config()) return of(false);

        return this.isAgentActivationRequired().pipe(
          switchMap((isRequired) => (isRequired ? this.phoneAgentActivationService.isActive$ : of(true)))
        );
      })
    );
  }

  private isAgentActivationRequired(): Observable<boolean> {
    const companiesIds = this.userService.getCurrentUser()?.companiesIds ?? [];
    if (!companiesIds.length) return of(false);

    return this.featureToggleService.companyCanAccess(
      companiesIds,
      FeatureToggles.ENABLED_GET_AGENT_ACTIVATION_LOG_LIVECHAT
    );
  }

  private checkUserHasCode7Config(): boolean {
    const customFields = this.userService.getCurrentUser()?.customFields;
    if (!customFields) return false;

    return (
      !!customFields.code7AgentEmail &&
      !!customFields.code7AgentId &&
      !!customFields.code7AgentPassword &&
      !!customFields.code7PhoneExtension
    );
  }
}
